import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/buildhome/repo/src/components/docs-layout.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <p>{`This document will guide you through installing your nice!nano and flashing. After following this document, you can move on to the Wireless Firmware page to pick out your software.`}</p>
    <h2 {...{
      "id": "before-you-start"
    }}>{`Before you start`}</h2>
    <p>{`Before you install your nice!nano please note these tips/warnings:`}</p>
    <blockquote>
      <p parentName="blockquote">{`When soldering the nice!nano, avoid using high iron temperatures, as you could damage the main nRF52840 chip. A temperature around 270°C-300°C should be hot enough. The higher the temperature, the more likely you are to damage the board.`}</p>
    </blockquote>
    <ul>
      <li parentName="ul">{`Do not install sockets or post headers to the B+ or B- pins (top pin on each side)`}
        <ul parentName="li">
          <li parentName="ul">{`If you need to use these pins with your PCB, RAW and GND are the respective equivalents to B+ and B-`}</li>
        </ul>
      </li>
      <li parentName="ul">{`The square post headers that come with the nice!nano cannot be used with the machine sockets`}
        <ul parentName="li">
          <li parentName="ul">{`Use Mill-Max pin legs or diode legs and follow the directions in `}<a parentName="li" {...{
              "href": "#installing-your-nicenano"
            }}>{`installing your nice!nano`}</a></li>
        </ul>
      </li>
      <li parentName="ul">{`Only use 3.7V rechargeable lithium batteries with the nice!nano. Connecting non-rechargeable batteries is unsafe`}</li>
      <li parentName="ul">{`If you choose to solder your battery, use the B+ and B- pins. B+ is for the positive, red wire, and the B- pin is for the negative, black wire. Minimize how long you are holding the soldering iron to the battery. High amounts of heat are dangerous to connect the battery to.`}</li>
      <li parentName="ul">{`If you are using a JST connector on the PCB to connect the battery, double or even quadruple check the polarity of the JST connector before plugging it in. Some batteries come with positive on the first pin and some come with negative on the first pin.`}</li>
    </ul>
    <h2 {...{
      "id": "installing-your-nicenano"
    }}>{`Installing your nice!nano`}</h2>
    <p>{`Installing your nice!nano is almost the same as any other Pro Micro like board. The only difference is related to ignore the B+ and B- pins when adding sockets or headers and `}<strong parentName="p">{`the battery`}</strong>{`. It's highly recommended to get your firmware on and functioning before adding the battery.`}</p>
    <p>{`If you aren't socketing, you probably want to get the firmware up and running before you even attach the square post headers. You'll want to install the firmware, confirm everything is working, and install your square post headers and battery.`}</p>
    <p>{`If you are socketing, you can socket your nice!nano, install the firmware, confirm everything is working, and finally add the battery.`}</p>
    <h3 {...{
      "id": "socketing-the-nicenano"
    }}>{`Socketing the nice!nano`}</h3>
    <p>{`Socketing the nice!nano is `}<em parentName="p">{`extremely`}</em>{` recommended. It offers ease of access to the battery, helps you if you need to debug your keyboard, and lets you move the board to another keyboard if ever needed.`}</p>
    <p>{`For a great guide with pictures check out `}<a parentName="p" {...{
        "href": "http://www.40percent.club/p/socketing-pro-micro.html"
      }}>{`40percentclub's guide`}</a>{`.`}</p>
    <p>{`Socketing steps:`}</p>
    <ol>
      <li parentName="ol">{`First install the socket into the PCB trying to keep it as straight as possible.`}</li>
      <li parentName="ol">{`Once the sockets are in, place tape over the top of each side.`}</li>
      <li parentName="ol">{`Poke holes where each socket hole is into the tape`}</li>
      <li parentName="ol">{`Place down the nice!nano (to assure alignment, `}<strong parentName="li">{`make sure the B+ and B- pins are not being put into the socket`}</strong>{`)`}</li>
      <li parentName="ol">{`Put MillMax pin legs (or diode legs) into each hole and push all the way down`}</li>
      <li parentName="ol">{`Solder the legs to the nice!nano (this is where the tape helps, solder wont seep down into the socket and fuse the socket and legs)`}</li>
      <li parentName="ol">{`Take the nice!nano out by using a pry tool of some sort. Slowly pry back and forth on all sides.`}</li>
      <li parentName="ol">{`Take away the tape and put the nice!nano back in.`}</li>
      <li parentName="ol">{`Done!`}</li>
    </ol>
    <h2 {...{
      "id": "flashing-firmware-and-bootloaders"
    }}>{`Flashing, Firmware, and Bootloaders`}</h2>
    <p>{`One of the great things about the nice!nano is how easy it is to flash the device. To jump into the bootloader all you need to do is double tap reset. You can do this by either double tapping your reset button on your keyboard, or you can double tap RST and GND pins on the nice!nano quickly with tweezers.`}</p>
    <p>{`Once you are into the bootloader, connect your nice!nano via USB to your computer if you haven't already. Your nice!nano should now show up in your OS as a USB storage device named "NICENANO".`}</p>
    <p>{`Flashing is now as easy as copying a .uf2 firmware file to the storage device. You can do this by copying in the terminal, dragging and dropping it in your file explorer, or however else you copy files to a storage device in your OS.`}</p>
    <p>{`Now you may be wondering how to get one of these mystical .uf2 files. You get them by building one of the firmwares available. Checkout the `}<a parentName="p" {...{
        "href": "/docs/wireless-firmware/"
      }}><strong parentName="a">{`Wireless Firmware`}</strong></a>{` page to get information on how to configure and build a few different types of firmwares along with some recommendations.`}</p>
    <p>{`The bootloader the nice!nano uses is the Adafruit nRF52 Bootloader. You can read more about its features, updating the bootloader, and using DFU to flash firmware on `}<a parentName="p" {...{
        "href": "https://github.com/adafruit/Adafruit_nRF52_Bootloader"
      }}>{`its GitHub`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      